// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-ACOsunxMeJDt9nW7tLIB"};